import { useEffect } from 'react';

export const useSetUserStatus = (isAuthenticated: boolean) => {
  useEffect(() => {
    window.BTBusiness = {
      ...window.BTBusiness,
      ot: { isLoggedIn: isAuthenticated },
    };
  }, [isAuthenticated]);
};
